import React from 'react';
import { Check, ChevronDown, ChevronRight, Clock, XIcon, Award } from 'lucide-react';
export function Sidebar({
  isOpen,
  onClose,
  isAssessmentComplete = false,
  isOnResultsScreen = false
}) {
  return <>
      {/* Overlay */}
      {isOpen && <div className="fixed inset-0 bg-black bg-opacity-50 z-40 md:hidden" onClick={onClose} data-id="element-477" />}
      {/* Sidebar */}
      <div className={`fixed md:static left-0 top-0 h-full bg-white z-50 w-72 transform transition-transform duration-300 ease-in-out ${isOpen ? 'translate-x-0' : '-translate-x-full md:translate-x-0'}`} data-id="element-478">
        {/* Mobile Header */}
        <div className="md:hidden flex items-center justify-between p-4 border-b border-gray-200 bg-gray-50" data-id="element-479">
          <div className="flex items-center gap-3" data-id="element-480">
            <div className="w-10 h-10 rounded-full bg-gray-200 flex items-center justify-center text-gray-600 text-sm" data-id="element-481">
              LT
            </div>
            <div data-id="element-482">
              <p className="font-semibold text-sm" data-id="element-483">Linda Taylor</p>
              <p className="text-xs text-gray-600" data-id="element-484">View Profile</p>
            </div>
          </div>
          <button onClick={onClose} className="p-2 hover:bg-gray-200 rounded-full transition-colors" data-id="element-485">
            <XIcon size={20} data-id="element-486" />
          </button>
        </div>
        <div className="p-6" data-id="element-487">
          <h1 className="text-xl font-bold" data-id="element-488">Introduction to Web Development</h1>
        </div>
        <div className="border-t border-gray-200 py-4" data-id="element-489">
          <h2 className="px-6 font-bold mb-2" data-id="element-490">Skill Content</h2>
          <SidebarSection title="Getting Started with HTML" expanded items={[{
          label: 'Introduction to HTML',
          completed: true
        }, {
          label: 'Basic HTML Tags',
          completed: true
        }, {
          label: 'HTML Document Structure',
          completed: true
        }]} data-id="element-491" />
          <SidebarSection title="CSS Fundamentals" expanded items={[{
          label: 'Introduction to CSS',
          completed: true
        }, {
          label: 'Selectors and Properties'
        }, {
          label: 'Box Model and Layout'
        }, {
          label: 'Responsive Design Basics'
        }]} data-id="element-492" />
          <SidebarSection title="JavaScript Basics" expanded items={[{
          label: 'Introduction to JavaScript',
          completed: true
        }, {
          label: 'Variables and Data Types',
          completed: true
        }, {
          label: 'Summative Assessment',
          completed: isAssessmentComplete,
          active: !isOnResultsScreen && !isAssessmentComplete
        }]} data-id="element-493" />
          <SidebarSection title="Conclusion" expanded={isOnResultsScreen || isAssessmentComplete} items={[{
          label: 'Assessment Results',
          icon: <Award size={14} className="text-blue-600" data-id="element-495" />,
          active: isOnResultsScreen,
          completed: isAssessmentComplete && !isOnResultsScreen
        }, {
          label: 'Certificate'
        }]} data-id="element-494" />
        </div>
      </div>
    </>;
}
function SidebarSection({
  title,
  items = [],
  expanded = false
}) {
  return <div className="mb-1" data-id="element-496">
      <div className="flex items-center justify-between px-6 py-2 cursor-pointer hover:bg-gray-50" data-id="element-497">
        <div className="flex items-center" data-id="element-498">
          <div className="w-5 h-5 rounded-full border border-gray-300 flex items-center justify-center mr-3" data-id="element-499">
            {expanded ? <ChevronDown size={16} data-id="element-500" /> : <ChevronRight size={16} data-id="element-501" />}
          </div>
          <span className="font-medium" data-id="element-502">{title}</span>
        </div>
      </div>
      {expanded && <div className="pl-6" data-id="element-503">
          {items.map((item, index) => <div key={index} className={`flex items-center py-2 px-6 ${item.active ? 'bg-blue-50' : 'hover:bg-gray-50'}`} data-id="element-504">
              <div className="w-5 h-5 rounded-full mr-3 flex items-center justify-center" data-id="element-505">
                {item.completed ? <div className="w-5 h-5 rounded-full bg-green-100 flex items-center justify-center" data-id="element-506">
                    <Check size={14} className="text-green-600" data-id="element-507" />
                  </div> : item.icon ? <div className="w-5 h-5 rounded-full bg-blue-100 flex items-center justify-center" data-id="element-508">
                    {item.icon}
                  </div> : <div className={`w-5 h-5 rounded-full border ${item.active ? 'border-blue-400' : 'border-gray-300'}`} data-id="element-509"></div>}
              </div>
              <span className="text-sm flex-1" data-id="element-510">{item.label}</span>
              {item.time && <div className="text-xs text-gray-500 flex items-center" data-id="element-511">
                  <Clock size={12} className="mr-1" data-id="element-512" />
                  {item.time}
                </div>}
            </div>)}
        </div>}
    </div>;
}